import { AutocompleteInput, BooleanInput, ReferenceInput, required, SelectInput, TextInput } from 'react-admin';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { RichTextInputCustom } from '../../components/RichTextInputCustom';
import { DevRequestType } from '../../models/devRequest';
import { filterToQuery } from '../../utils';
import { typeChoices, typeHint } from './labels';

// Constante de módulo: defaultValues que muda a cada render dá reset() no formulário inteiro.
export const DEFAULT_VALUES = { type: DevRequestType.feature, urgent: false };

/** Rede vazia vira '' (o backend aceita guid ou vazio); o resto segue como digitado. */
export const toPayload = (data: any) => {
  const payload = { ...data, chainId: data.chainId || '', referenceUrl: data.referenceUrl || '' };
  delete payload.events; // só vêm no GET /dev-requests/{id}; o objeto novo escaparia do diff do update.ts
  delete payload.totals;
  return payload;
};

const TypeInput = () => {
  const type = useWatch({ name: 'type' }) as DevRequestType | undefined;
  return (
    <SelectInput
      source="type"
      label="Tipo"
      choices={typeChoices()}
      validate={required()}
      helperText={typeHint(type) || false}
      sx={{ width: 360, maxWidth: '100%' }}
    />
  );
};

const DevRequestFields = () => (
  <Box sx={{ maxWidth: 920, width: '100%' }}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, alignItems: 'flex-start' }}>
      <TextInput source="title" label="Título" validate={required()} inputProps={{ maxLength: 160 }} sx={{ width: 480, maxWidth: '100%' }} />
      <TypeInput />
    </Box>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 2, alignItems: 'flex-start' }}>
      <TextInput source="requesterName" label="Quem pediu" inputProps={{ maxLength: 120 }} sx={{ width: 320, maxWidth: '100%' }} />
      <ReferenceInput source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={25}>
        <AutocompleteInput label="Rede (opcional)" optionText="name" filterToQuery={filterToQuery} sx={{ width: 320, maxWidth: '100%' }} />
      </ReferenceInput>
    </Box>
    <TextInput source="referenceUrl" label="URL de referência (opcional)" sx={{ width: 640, maxWidth: '100%' }} />
    <BooleanInput
      source="urgent"
      label="Urgente"
      helperText="Urgente começa em até 1 minuto; normal, em até 1 hora."
    />
    <RichTextInputCustom source="body" label="Descrição" validate={required()} />
  </Box>
);

export default DevRequestFields;
